import { render, staticRenderFns } from "./MessageSearchResult.vue?vue&type=template&id=9376b452&scoped=true&"
import script from "./MessageSearchResult.vue?vue&type=script&lang=ts&"
export * from "./MessageSearchResult.vue?vue&type=script&lang=ts&"
import style0 from "./MessageSearchResult.vue?vue&type=style&index=0&id=9376b452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9376b452",
  null
  
)

export default component.exports